import { useMutation } from "@tanstack/react-query"
import { apiClient } from "~/lib/client"
import { handleError, handleResponse } from "~/utils/response"
import { AllergyUpdateVariables, AllergyVariables } from "../../schemas"

import { CreateAllergyResponse, CreateAllergyResponseData, UpdateAllergyResponse, UpdateAllergyResponseData } from "../types"

export const useCreateAllergyMutation = () => {
    return useMutation<CreateAllergyResponse, unknown, AllergyVariables>({
      mutationFn: async (variables: AllergyVariables) => {
        try {
          const response = await apiClient("/medicals/allergies", {
            method: "POST",
            body: JSON.stringify(variables),
          });
  
          return await handleResponse<CreateAllergyResponseData>(response);

        } catch (error) {
          return handleError(error);
        }
      },
    });
  };

export const useUpdateAllergyMutation = () => {
    return useMutation<UpdateAllergyResponse, unknown, AllergyUpdateVariables>({
      mutationFn: async (variables: AllergyUpdateVariables) => {
        try {
          const response = await apiClient(`/medicals/allergies/${variables.id}`, {
            method: "PUT",
            body: JSON.stringify(variables),
          });
  
          return await handleResponse<UpdateAllergyResponseData>(response);
        } catch (error) {
          return handleError(error);
        }
      },
    });
  }; 




